__webpack_require__.p = "https://assets.cannisters.cafe/5d25a53ec570f66dfccb18880af4153bc1504a4b/";